module.exports = __webpack_public_path__ + "img/more.abf9ce81.svg";